module.exports = __webpack_public_path__ + "img/logos/ios-app-icon-81ca5303c7c2ec0744cd226a0794c87e.svg";